import { RlFile } from "../../../file/shared/rl-file";

export class ServerEntity {
    id? : string;
    createDate? : string;
    modificationDate? : string;
    
    setProperty(prop : string, val : any){
        this[prop] = val;
    }

    setFile(file : RlFile){
        this.setProperty("amazonFileKey", file.amazonFileKey);
        this.setProperty("amazonDisplayFileName", file.amazonDisplayFileName);
        this.setProperty("amazonFileUrl", file.url);
    }
}
